export default "__VITE_ASSET__yNEAEZmC__"